export default __webpack_public_path__ + "static/media/longest_call.2535d74e.svg";